"use strict";
/**
 * 数据中心接口
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KCBAshareData = exports.RZRQYE = exports.RZRQHistoryData = void 0;
var web_1 = __importDefault(require("../../config/web"));
/**
 * 融资融券历史数据
 */
function RZRQHistoryData(market) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var back, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, $.ajax({
                            url: "".concat(web_1.default.getUrl('datacenter_api'), "api/data/v1/get?callback=?"),
                            type: 'GET',
                            dataType: 'jsonp',
                            data: {
                                reportName: 'RPTA_WEB_RZRQ_LSSH',
                                columns: 'RZYE,DIM_DATE,XOB_MARKET_0001,SCDM',
                                quoteColumns: '',
                                filter: market == 'sh' ? '(SCDM="007")' : '(SCDM="001")',
                                pageNumber: 1,
                                pageSize: 240,
                                sortTypes: -1,
                                sortColumns: 'DIM_DATE',
                                source: 'QuoteWeb',
                                client: 'WEB'
                            }
                        })];
                case 1:
                    back = _b.sent();
                    if (((_a = back === null || back === void 0 ? void 0 : back.result) === null || _a === void 0 ? void 0 : _a.data) instanceof Array) {
                        return [2 /*return*/, back.result.data];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _b.sent();
                    console.error(error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/, []];
            }
        });
    });
}
exports.RZRQHistoryData = RZRQHistoryData;
/**
 * 沪深京三市融资余额
 * @param params
 */
function RZRQYE() {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var back, error_2;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, $.ajax({
                            url: "".concat(web_1.default.getUrl('datacenter_api'), "api/data/get?callback=?"),
                            type: 'GET',
                            dataType: 'jsonp',
                            data: {
                                type: 'RPT_MARGIN_MARGINPROFILE',
                                sty: 'TRADE_DATE,MARKET,BOARD_CODE,FIN_BALANCE,LOAN_BALANCE,MARGIN_BALANCE,FIN_BUY_AMT',
                                extraCols: '',
                                filter: '',
                                p: 1,
                                ps: 5,
                                sr: '',
                                st: '',
                                token: '',
                                var: '',
                                source: 'QuoteWeb',
                                client: 'WEB'
                            }
                        })];
                case 1:
                    back = _b.sent();
                    if (((_a = back === null || back === void 0 ? void 0 : back.result) === null || _a === void 0 ? void 0 : _a.data) instanceof Array) {
                        return [2 /*return*/, back.result.data];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_2 = _b.sent();
                    console.error(error_2);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/, []];
            }
        });
    });
}
exports.RZRQYE = RZRQYE;
/**
 * 科创板数据
 * @param params
 */
function KCBAshareData(pageindex, pagesize) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var back, error_3;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, $.ajax({
                            url: "".concat(web_1.default.getUrl('datacenter_api'), "web/api/data/v1/get?callback=?"),
                            type: 'GET',
                            dataType: 'jsonp',
                            data: {
                                reportName: 'RPT_KCB_ASHARE_CONCEPT',
                                columns: 'SECUCODE,SECURITY_CODE,SECURITY_INNER_CODE,SECURITY_NAME_ABBR,MARKET_TYPE,RELATED_STOCK,TRADE_MARKET_CODE,SECURITY_TYPE_CODE',
                                quoteColumns: '',
                                pageNumber: pageindex,
                                pageSize: pagesize,
                                sortTypes: '',
                                sortColumns: '',
                                source: 'QuoteWEB',
                                client: 'WEB'
                            }
                        })];
                case 1:
                    back = _b.sent();
                    if (((_a = back === null || back === void 0 ? void 0 : back.result) === null || _a === void 0 ? void 0 : _a.data) instanceof Array && back.result.pages != undefined) {
                        return [2 /*return*/, {
                                count: back.result.pages * pagesize,
                                data: back.result.data.map(function (v) {
                                    var bcdata = v.RELATED_STOCK.split(',');
                                    return {
                                        quotecode: v.MARKET_TYPE + '.' + v.SECURITY_CODE,
                                        cgdata: bcdata.map(function (bc) {
                                            var cgdata_item = bc.split('|');
                                            return {
                                                bcgs: cgdata_item[1],
                                                cgbl: cgdata_item[2],
                                                sbzt: cgdata_item[4],
                                            };
                                        })
                                    };
                                })
                            }];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_3 = _b.sent();
                    console.error(error_3);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/, {
                        count: 0,
                        data: []
                    }];
            }
        });
    });
}
exports.KCBAshareData = KCBAshareData;
